import { EventSource } from "eventsource";
const ERROR_PREFIX = "[ERROR]";
const DONE_MESSAGE = "[DONE]";
export default class Stream {
  constructor(apiEndpoint) {
    this.apiUrl = `${process.env.VUE_APP_AI_URL}${apiEndpoint}?stream=1`;
    this.instance = undefined;
    this.message = "";
  }

  connect() {
    const token = process.env.VUE_APP_AI_AUTH_TOKEN;
    this.instance = new EventSource(this.apiUrl, {
      fetch: (input, init) => {
        // Clone init to avoid mutation
        const options = { ...init };
        const headers = new Headers(init?.headers);
        if (token) {
          headers.set("Authorization", token);
        }
        options.headers = headers;
        return fetch(input, options);
      },
    });
  }

  onError(errorHandler) {
    this.instance.onerror = errorHandler;
  }

  onMessage(callback) {
    return new Promise((resolve, reject) => {
      this.instance.onmessage = (event) => {
        this.verifyOrigin(event.origin);
        if (event.data.trim() === DONE_MESSAGE) {
          resolve("Success");
          this.close();
          return;
        }

        const trimmed = event.data.trim();
        if (trimmed.startsWith(ERROR_PREFIX)) {
          reject(trimmed);
          this.close();

          return;
        }
        this.message += event.data;
        callback(this.message);
      };
    });
  }

  close() {
    this.instance.close();
  }

  verifyOrigin(origin) {
    const apiUrl = new URL(process.env.VUE_APP_AI_URL);

    if (apiUrl.origin !== origin) {
      this.close();
      return;
    }
  }
}
